import React, { useState, useEffect, useContext } from "react";
import FontPicker from "font-picker-react";
import { setStateSurveyConfiguration } from "../../helpers/StateSurveyConfiguration";
import {
  FontsFormContainer,
  TitleContainer,
  EditSection,
  FontSection,
  FontFieldSection,
  StyledButton,
} from "./FontsFormStyle.styled.js";
import { ContextQuestions } from "../../Store/StoreQuestions";
import { theme as themeConfig } from "../../themes/themes";

const FontsFormStyle = ({ pickerId, apiKey, title, styleFormAll }) => {
  const [, dispatch] = useContext(ContextQuestions);

  const [activeFontFamily, setActiveFontFamily] = useState("Open Sans");
  const [fontSize, setfontSize] = useState(16);
  const [color, setColor] = useState("#000000");

  const [styleBold, setStyleBold] = useState({ fontWeight: "bold" });
  const [styleItalic, setStyleItalic] = useState({ fontStyle: "italic" });
  const [styleUnderline, setStyleUnderline] = useState({
    textDecoration: "underline",
  });
  const [styleLineThrough, setStyleLineThrough] = useState({
    textDecoration: "line-through",
  });

  const [styleForm, setStyleForm] = useState({
    fontWeight: "normal",
    fontStyle: "normal",
    textDecoration: "none",
    fontFamily: "Open Sans",
    color: themeConfig.neutral.black,
    fontSize: "none",
  });

  useEffect(() => {
    if (styleFormAll) {
      setStyleForm(styleFormAll);

      if (styleFormAll.fontFamily !== "") {
        setActiveFontFamily(styleFormAll.fontFamily);
      }
      if (styleFormAll.fontSize) {
        setfontSize(styleFormAll.fontSize.slice(0, 2));
      }
      setColor(styleFormAll.color);

      if (styleFormAll.fontWeight === "bold") {
        setStyleBold({ fontWeight: "bold", background: "rgba(46, 46, 46, 0.1)" });
      }
      if (styleFormAll.fontStyle === "italic") {
        setStyleItalic({
          fontStyle: "italic",
          background: "rgba(46, 46, 46, 0.1)",
        });
      }
      if (styleFormAll.textDecoration === "underline") {
        setStyleUnderline({
          textDecoration: "underline",
          background: "rgba(46, 46, 46, 0.1)",
        });
      }
      if (styleFormAll.textDecoration === "line-through") {
        setStyleLineThrough({
          textDecoration: "line-through",
          background: "rgba(46, 46, 46, 0.1)",
        });
      }
    }
  }, [styleFormAll]);

  let handleLetteringStyle = (type, item) => {
    let StyleBotton = "";
    let updateStyleForm = Object.assign({}, styleForm);

    switch (type) {
      case "styleFont":
        switch (item.target.innerText) {
          case "N":
            if (
              updateStyleForm.fontWeight &&
              updateStyleForm.fontWeight !== "normal"
            ) {
              updateStyleForm.fontWeight = "normal";
              StyleBotton = { fontWeight: "bold" };
            } else {
              updateStyleForm.fontWeight = "bold";
              StyleBotton = {
                fontWeight: "bold",
                background: "rgba(46, 46, 46, 0.1)",
              };
            }
            setStyleBold(StyleBotton);
            break;
          case "K":
            if (
              updateStyleForm.fontStyle &&
              updateStyleForm.fontStyle !== "normal"
            ) {
              updateStyleForm.fontStyle = "normal";
              StyleBotton = { fontStyle: "italic" };
            } else {
              updateStyleForm.fontStyle = "italic";
              StyleBotton = {
                fontStyle: "italic",
                background: "rgba(46, 46, 46, 0.1)",
              };
            }
            setStyleItalic(StyleBotton);
            break;
          case "S":
            if (
              updateStyleForm.textDecoration &&
              updateStyleForm.textDecoration !== "none" &&
              updateStyleForm.textDecoration !== "line-through"
            ) {
              updateStyleForm.textDecoration = "none";
              StyleBotton = { textDecoration: "underline" };
            } else {
              updateStyleForm.textDecoration = "underline";
              StyleBotton = {
                textDecoration: "underline",
                background: "rgba(46, 46, 46, 0.1)",
              };
            }
            setStyleUnderline(StyleBotton);
            setStyleLineThrough({ textDecoration: "line-through" });
            break;
          case "ab":
            if (
              updateStyleForm.textDecoration &&
              updateStyleForm.textDecoration !== "none" &&
              updateStyleForm.textDecoration !== "underline"
            ) {
              updateStyleForm.textDecoration = "none";
              StyleBotton = { textDecoration: "line-through" };
            } else {
              updateStyleForm.textDecoration = "line-through";
              StyleBotton = {
                textDecoration: "line-through",
                background: "rgba(46, 46, 46, 0.1)",
              };
            }
            setStyleLineThrough(StyleBotton);
            setStyleUnderline({ textDecoration: "underline" });
            break;
          default:
            break;
        }

        break;
      case "typeFont":
        setActiveFontFamily(item);
        updateStyleForm.fontFamily = item;
        break;
      case "color":
        setColor(item.target.value);
        updateStyleForm.color = item.target.value;
        break;
      case "size":
        setfontSize(item.target.value);
        updateStyleForm.fontSize = item.target.value + "px";
        break;
      default:
        break;
    }
    if (title === "Questions") {
      dispatch({ type: "QUESTIONS_STYLE", payload: updateStyleForm });
    } else if (title === "Answer") {
      dispatch({ type: "ANSWERS_STYLE", payload: updateStyleForm });
    }

    setStateSurveyConfiguration(updateStyleForm, title);
  };

  return (
    <FontsFormContainer>
      <TitleContainer>{title}</TitleContainer>
      <EditSection>
        <FontSection>
          <FontPicker
            pickerId={pickerId}
            apiKey={apiKey}
            activeFontFamily={
              styleFormAll && styleFormAll.fontFamily
                ? styleFormAll.fontFamily
                : activeFontFamily
            }
            limit={100}
            onChange={(event) => handleLetteringStyle("typeFont", event.family)}
          />

          <input
            type="number"
            onChange={(event) => handleLetteringStyle("size", event)}
            min={16}
            max={50}
            value={fontSize}
            placeholder="Size"
          />
        </FontSection>
        <FontFieldSection>
          <StyledButton
            onClick={(event) => handleLetteringStyle("styleFont", event)}
            style={styleBold}
          >
            N
          </StyledButton>
          <StyledButton
            onClick={(event) => handleLetteringStyle("styleFont", event)}
            style={styleItalic}
          >
            K
          </StyledButton>
          <StyledButton
            onClick={(event) => handleLetteringStyle("styleFont", event)}
            style={styleUnderline}
          >
            S
          </StyledButton>
          <StyledButton
            onClick={(event) => handleLetteringStyle("styleFont", event)}
            style={styleLineThrough}
          >
            ab
          </StyledButton>
          <input
            type="color"
            onChange={(event) => handleLetteringStyle("color", event)}
            defaultValue={color}
            name="color"
            className="ColorPicker"
          />
        </FontFieldSection>
      </EditSection>
    </FontsFormContainer>
  );
};

export default FontsFormStyle;
